import { CONSENT_REQUEST_TYPE } from "@core/constants"
import type { ConsentSentModalPayload } from "./consent-request-send-dialog.types"

export type ConsentRequestSendOverlayData = {
    isMultiRequest: boolean
    requestId: string
    url?: string
    type: string
    sourceId?: string
    consentRequestMulti: {
        requestId: string
        url: string
        type: string
    }
}

/**
 * Décide le contenu de la modale v6 pour l’envoi / relance d’invitation consentement.
 */
export function resolveConsentRequestSendInvitation(
    data: ConsentRequestSendOverlayData,
    reqType: string | undefined,
    config: { sendBack: boolean }
): { mode: "dialog"; dialogPayload: ConsentSentModalPayload } {
    const multi = data.isMultiRequest
    const requestId = multi
        ? data.consentRequestMulti.requestId
        : data.requestId
    const url = multi ? data.consentRequestMulti.url : data.url

    const rid = requestId ?? ""

    if (reqType === CONSENT_REQUEST_TYPE.CHANGE_OWNER) {
        return {
            mode: "dialog",
            dialogPayload: {
                kind: "change-owner",
                requestId: rid,
                link: url ?? "",
                sendBack: config.sendBack,
            },
        }
    }

    if (reqType === CONSENT_REQUEST_TYPE.SHARE) {
        return {
            mode: "dialog",
            dialogPayload: {
                kind: "share",
                requestId: rid,
                link: url ?? "",
                sendBack: config.sendBack,
                multiple: !!multi,
            },
        }
    }

    if (
        reqType === CONSENT_REQUEST_TYPE.SIGN ||
        reqType === CONSENT_REQUEST_TYPE.EXTEND
    ) {
        return {
            mode: "dialog",
            dialogPayload: {
                kind: "sign",
                requestId: rid,
                link: url ?? "",
                sendBack: config.sendBack,
                multiple: !!multi,
                consentRequestType: reqType,
            },
        }
    }

    return {
        mode: "dialog",
        dialogPayload: {
            kind: "sign",
            requestId: rid,
            link: url ?? "",
            sendBack: config.sendBack,
            multiple: !!multi,
            consentRequestType: reqType ?? CONSENT_REQUEST_TYPE.SIGN,
        },
    }
}
